import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/Home.css";
import { Container, Row } from "react-bootstrap";
import Fondo from "../imagenes/login2.png";

const Home = () => {
  return (
    <>
      <div
        className="background-container"
        style={{
          backgroundImage: `url(${Fondo})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: "100vh", // que abarque toda la altura de la pantalla
          width: "100%",       // que use todo el ancho
          margin: 0,
          padding: 0,
          display: "flex",
          alignItems: "center",     // centra verticalmente
          justifyContent: "center", // centra horizontalmente
          flexDirection: "column",  // apila contenido verticalmente
        }}
      >
        <Container>
          <Row>
            <div class="col"
            style={{ 
              marginLeft: "auto", 
              textAlign: "right", 
              maxWidth: "500px",
            }}
            >
              <p style={{ color: "white", fontSize: "25px", fontWeight: "bold" }}>Aqui puedes conocer los procesos de:</p>
              <p style={{ color: "white", fontWeight: "bold" }}>- Ingenieria</p>
              <p style={{ color: "white", fontWeight: "bold" }}>- Ventas</p>
              <p style={{ color: "white", fontWeight: "bold" }}>- Operaciones</p>
              <p style={{ color: "white", fontWeight: "bold" }}>- Gestion de servicios</p>
              <p style={{ color: "white", fontWeight: "bold" }}>- Administracion de servicios</p>
              <p style={{ color: "white", fontWeight: "bold" }}>- Desarrollo de software</p> 
              <p style={{ color: "white", fontWeight: "bold" }}>- Tickets</p> 
              <br></br>
            </div>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Home;
